import { PromptFunction } from '../types';
import { builtinFunctions } from './builtinFunctions';
import { customFunctions } from './customFunctions';

export const promptAllFunctions: Record<string, PromptFunction> = {
  ...builtinFunctions,
  ...customFunctions
}